import { useState, useEffect } from 'react';
const pub = process.env.PUBLIC_URL;

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isHome = window.location.pathname === '/';

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const showBg = scrolled || !isHome;

  const links = [
    { label: 'Home', href: isHome ? '#hero' : '/' },
    { label: 'The Project', href: '/project' },
    { label: 'Rooms', href: isHome ? '#rooms' : '/#rooms' },
    { label: 'Experience', href: isHome ? '#experiences' : '/#experiences' },
    { label: 'Contact', href: isHome ? '#contact' : '/#contact' },
  ];

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
        height: 'var(--nav-height)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 48px',
        background: showBg ? 'rgba(14,12,10,0.96)' : 'transparent',
        borderBottom: showBg ? '1px solid rgba(200,150,60,0.15)' : 'none',
        transition: 'background 0.4s ease',
      }}>
        <a href={isHome ? '#hero' : '/'}>
          <img src={`${pub}/logo.png`} alt="Silverkammer" style={{ height: '40px', width: 'auto' }} />
        </a>
        <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
          {links.map((l, i) => (
            <a key={i} href={l.href} style={{ fontFamily: 'var(--font-body)', fontSize: '11px', letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.75)', transition: 'color 0.2s', display: window.innerWidth < 900 ? 'none' : 'block' }}
              onMouseEnter={e => e.target.style.color = 'var(--gold2)'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.75)'}
            >{l.label}</a>
          ))}
          <div style={{ display: 'flex', gap: '12px' }}>
            <a href="#contact" style={{ fontFamily: 'var(--font-body)', fontSize: '10px', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--gold2)', border: '1px solid rgba(200,150,60,0.5)', padding: '7px 16px', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.target.style.background='var(--gold)'; e.target.style.color='white'; e.target.style.borderColor='var(--gold)'; }}
              onMouseLeave={e => { e.target.style.background='transparent'; e.target.style.color='var(--gold2)'; e.target.style.borderColor='rgba(200,150,60,0.5)'; }}
            >Log In</a>
            <a href="#contact" style={{ fontFamily: 'var(--font-body)', fontSize: '10px', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--dark)', background: 'var(--gold)', padding: '7px 16px', transition: 'opacity 0.2s' }}
              onMouseEnter={e => e.target.style.opacity='0.85'} onMouseLeave={e => e.target.style.opacity='1'}
            >Sign Up</a>
          </div>
          <button onClick={() => setOpen(!open)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
            {[0,1,2].map(i => (
              <span key={i} style={{
                display: 'block', width: open ? (i===1?'0':'24px') : (i===1?'16px':'24px'), height: '1px', background: 'var(--offwhite)',
                transition: 'all 0.3s ease',
                transform: open ? (i===0?'rotate(45deg) translate(4px,4px)':i===2?'rotate(-45deg) translate(4px,-4px)':'none') : 'none',
                opacity: open&&i===1?0:1,
              }} />
            ))}
          </button>
        </div>
      </nav>

      {/* Overlay */}
      <div style={{
        position: 'fixed', inset: 0, zIndex: 190,
        background: 'rgba(14,12,10,0.97)',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        paddingTop: 'var(--nav-height)', gap: '6px',
        opacity: open ? 1 : 0, pointerEvents: open ? 'all' : 'none',
        transition: 'opacity 0.35s ease',
      }}>
        {links.map((l, i) => (
          <a key={i} href={l.href} onClick={() => setOpen(false)}
            style={{ fontFamily: 'var(--font-title)', fontWeight: 400, fontSize: 'clamp(1.8rem,4vw,3.2rem)', color: 'var(--offwhite)', lineHeight: 1.3, transition: 'color 0.2s, transform 0.2s' }}
            onMouseEnter={e => { e.target.style.color='var(--gold2)'; e.target.style.transform='translateX(8px)'; }}
            onMouseLeave={e => { e.target.style.color='var(--offwhite)'; e.target.style.transform='translateX(0)'; }}
          >{l.label}</a>
        ))}
        <div style={{ position: 'absolute', bottom: '32px', left: '48px', right: '48px', height: '1px', background: 'var(--border)' }} />
      </div>
    </>
  );
}
